import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { logout } from '../api';
import { removeAuthToken } from '../utils';

export const useLogout = () => {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: logout,
    onSettled: () => {
      removeAuthToken();
      navigate('/');
    },
  });

  return mutation;
};
